import { Toast } from "bootstrap";
import { MapBrowserEvent } from "ol";
import { platformModifierKeyOnly, touchOnly } from "ol/events/condition";
import Interaction from "ol/interaction/Interaction";
import { createToast } from "./toasts";

export default class ZoomHint extends Interaction {
    activePointers: number[];
    ctrlToast:Toast;
    twoFingerToast:Toast;

    constructor() {
        super();
        this.activePointers = [];
        this.ctrlToast = createToast("Pre pohyb mapy podrž kláves Ctrl");
        this.twoFingerToast = createToast("Na interakciu s mapou použi 2 prsty");
    }

    handleEvent(mapBrowserEvent: MapBrowserEvent<any>): boolean {
        if (mapBrowserEvent.originalEvent.pointerType == "touch" && (mapBrowserEvent.type == "pointerup" || mapBrowserEvent.type == "pointerdown")) {
            if (mapBrowserEvent.type == "pointerup") {
                this.activePointers = this.activePointers.filter(p => p != mapBrowserEvent.originalEvent.pointerId);
            } else {
                this.activePointers.push(mapBrowserEvent.originalEvent.pointerId);
            }
        }

        if ((mapBrowserEvent.type == "wheel" || mapBrowserEvent.type == "pointerdrag") 
            && !platformModifierKeyOnly(mapBrowserEvent) 
            && !touchOnly(mapBrowserEvent)
        ) {
            this.ctrlToast.show();
        } else if (touchOnly(mapBrowserEvent) 
            && !mapBrowserEvent.originalEvent.target.matches(".control-container *")
            && mapBrowserEvent.type == "pointerdrag" 
            && this.activePointers.length < 2 
            && !this.getMap().get("isFullscreen")
        ) {
            this.twoFingerToast.show();
        }
        return true;
    }
}